<ngx-smart-modal #CreateAnalysisProgressBarModal 
    [identifier]="modalType"
    [title]="modalTitle"
    [closable]="false"
    [showCloseButton]="false"
    [showConfirmButton]="false"
    [escapable]="false"
    [dismissible]="false">
        <hr class="popover-line">
        <p class="description">
            {{ description }}
        </p>
        <lib-progress
            class="launch-analysis-loading-bar"
            id="launch-analysis-loading-bar"
            #progressBar
            [loader]="true"
            [spinner]="false"
            [spinnerPosition]="'center'"
            [thick]="true"
            (completed)="onCompleted()"
        >
        </lib-progress>
        <span class="spacer"></span>
</ngx-smart-modal>